import React from "react";

export default function GlobalBackground() {
  return (
    <div className="global-bg" aria-hidden="true">
      <div className="global-glow global-glow-1" />
      <div className="global-glow global-glow-2" />
    </div>
  );
}
